import React, { useState } from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { VFText, SectionHeader, QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages } from '../../../Themes';
import InProgressOrdersSubCard from '../InProgressOrdersSubCard/InProgressOrdersSubCard';
import OrderSummaryDataModal from '../OrderSummaryDataModal';

import styles from './InProgressOrdersCard.styles';

const InProgressOrdersCard = ({ order }) => {
  const theme = useTheme();
  const images = getThemeImages(theme.name);

  const [isOrderSummaryModal, setOrderSummaryModal] = useState(false);

  const onOpenOrderSummaryModal = () => {
    setOrderSummaryModal(true);
  };
  const onCloseOrderSummaryModal = () => {
    setOrderSummaryModal(false);
  };

  return (
    <View style={styles.container}>
      <SectionHeader
        theme={theme}
        title="my_orders_order_number"
        titleStyle={styles.titleStyle(theme)}
        rightIcon={images.icon_bill_report_generic}
        rightText="my_orders_action_order_summary"
        rightTextStyle={styles.rightText}
        subtitle={order.id.toString()}
        subtitleStyle={styles.subtitle(theme)}
        onRightSectionPress={onOpenOrderSummaryModal}
        style={styles.sectionHeaderContainerStyle}
      />
      <VFText
        style={styles.orderDate(theme)}
        i18nKey="my_orders_order_placed_title"
        placeHolders={[order.date]}
      />

      {order.items.map((item, index) => (
        <InProgressOrdersSubCard key={index} orderId={order.id} item={item} />
      ))}

      {isOrderSummaryModal ? (
        <QuickActionMenu
          isVisible={isOrderSummaryModal}
          closeModal={onCloseOrderSummaryModal}
          title={'my_orders_action_order_summary'}
          type="secondary"
          titleStyle={styles.QAMtitle}
          headerStyle={styles.header}
          containerStyle={styles.QAMContainerStyle}
          notScrollable
          toggleModal={() => {}}
        >
          <OrderSummaryDataModal order={order} />
        </QuickActionMenu>
      ) : null}
    </View>
  );
};

InProgressOrdersCard.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    date: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default InProgressOrdersCard;
